import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Box, CircularProgress, Typography, Alert } from '@mui/material';
import CardTemplate1 from './CardTemplate1';
import CardTemplate2 from './CardTemplate2';

const PublicCardViewer = () => {
  const { cardId } = useParams();
  const [cardData, setCardData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCard = async () => {
      try {
        setLoading(true);
        // In a real implementation, this would fetch from your API
        // For now, we'll use mock data based on the cardId
        const mockCardData = {
          id: cardId,
          name: 'John Doe',
          title: 'Software Engineer',
          company: 'Tech Solutions Inc.',
          email: 'john.doe@example.com',
          phone: '+1 (555) 123-4567',
          location: 'New York, NY',
          bio: 'Passionate software engineer with 5+ years of experience in web development and cloud technologies.',
          linkedin: 'https://linkedin.com/in/johndoe',
          twitter: 'https://twitter.com/johndoe',
          instagram: 'https://instagram.com/johndoe',
          facebook: 'https://facebook.com/johndoe',
          website: 'https://johndoe.com',
          template: 'template1', // or 'template2'
        };

        // Simulate API call
        await new Promise(resolve => setTimeout(resolve, 1000));
        setCardData(mockCardData);
      } catch (err) {
        setError('Failed to load card data');
      } finally {
        setLoading(false);
      }
    };

    if (cardId) {
      fetchCard();
    }
  }, [cardId]);

  if (loading) {
    return (
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: '#f8fafc',
        }}
      >
        <Box sx={{ textAlign: 'center' }}>
          <CircularProgress size={60} />
          <Typography variant="h6" sx={{ mt: 2, color: 'text.secondary' }}>
            Loading card...
          </Typography>
        </Box>
      </Box>
    );
  }

  if (error) {
    return (
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: '#f8fafc',
          p: 2,
        }}
      >
        <Alert severity="error" sx={{ maxWidth: 400 }}>
          {error}
        </Alert>
      </Box>
    );
  }

  if (!cardData) {
    return (
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: '#f8fafc',
          p: 2,
        }}
      >
        <Alert severity="warning" sx={{ maxWidth: 400 }}>
          Card not found
        </Alert>
      </Box>
    );
  }

  // Render the appropriate template
  if (cardData.template === 'template2') {
    return <CardTemplate2 cardData={cardData} />;
  }

  // Default to template1
  return <CardTemplate1 cardData={cardData} />;
};

export default PublicCardViewer;






